import { PropTypes } from "prop-types";
import { useEffect, useRef } from "react";
import reactWrapper from "@harbor/elements/utils/react/wrapper";
import { useI18n } from "../../../../i18n/useI18n";

const [HbrButton, HbrTextArea] = reactWrapper(["hbr-button", "hbr-textarea"]);

const ChatForm = ({ miniState, setInput }) => {
    const { tCommon } = useI18n('common');
    const inputRef = useRef(null);

    const saveInput = (event) => {
        event.preventDefault();
        inputRef.current = event.target.value;
    };

    // Set up the Enter key handler only once using useEffect
    const handleKeyDown = (event) => {
        if (event.key === "Enter") {
            event.preventDefault();
            sendMessage();
        }
    };

    // No need for DOM event listeners in React
    useEffect(() => {
        // Reset ref when component unmounts
        return () => {
            inputRef.current = null;
        };
    }, []);

    const sendMessage = () => {
        const tempInput = inputRef.current;
        inputRef.current = "";
        setInput(tempInput);
    }

    return (
        <>
            <div>
                {(((miniState.spinner === false) && miniState.thread === null && !miniState.error)) && <div className="hbrchat-placeholder placeholder">
                    <hbr-illustration
                        className="hbrchat-placeholder-hero"
                        name="lens-logo"
                        static-colors
                        width="100px"
                        height="100px"
                    >
                        <div slot="heading" className="hbr-css__text-heading-xl-bold">
                            {tCommon('explainWidgetHowCanI')}
                        </div>
                        <div slot="body" className="hbr-css__text-primary-sm">
                            {""}
                        </div>
                    </hbr-illustration>
                </div>}

                {miniState.error &&
                    <hbr-chat-message variant="assistant">
                        <div>{tCommon('explainWidgetChatErrorChat')}</div>
                    </hbr-chat-message>}
            </div>
            <div className="hbr-css__chat-form">
                <HbrTextArea
                    rows="1"
                    placeholder={tCommon('explainWidgetChatPlaceholderChat')}
                    resize="auto"
                    class="hbr-css__chat-input"
                    id="chatInputTextarea"
                    autocomplete
                    value={inputRef.current}
                    onHbr-input={saveInput}
                    onKeyDown={handleKeyDown}
                >
                    <HbrButton
                        variant="text"
                        slot="suffix"
                        onClick={() => sendMessage()}
                    >
                        <hbr-icon name="paper-plane-right" size="24px" static-colors />
                    </HbrButton>
                </HbrTextArea>
                <div className="hbr-css__chat-disclaimer">
                    {tCommon('explainWidgetChatDisclaimer') + (miniState?.thread && miniState.thread[0]?.sessionid ? ` Session ID: ${miniState.thread[0].sessionid}` : "")}
                </div>
            </div>
        </>
    );
}
ChatForm.propTypes = {
    setInput: PropTypes.func,
    miniState: PropTypes.shape({
        thread: PropTypes.array,
        spinner: PropTypes.bool,
        error: PropTypes.string
    })
}
export default ChatForm;